import React, { useContext, useEffect, useRef, useState } from "react";
import Header4 from "../components/Header4";
import { Card, Form, InputGroup, Modal } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header3 from "../components/Header3";
import { useLocation, useSearchParams } from "react-router-dom";

import { useAuth } from "../context/auth";
import axios from "../AxiosInstance";
import toast from "react-hot-toast";
import { BASE_URL } from "../config/BaseUrls";
import { ChatState } from "../context/ChatProvider";
import { LanguageContext } from "../context/LanguageContext";
import { BsQuestionCircleFill } from "react-icons/bs";
import Spinner from "react-bootstrap/Spinner";
import { ChevronDown, Star } from "lucide-react";
import {  resolveBookImageUrl } from "../utils/urlHelpers";
const PRIMARY = "#34c3c9";
// ---- Helpers --------------------------------------------------------------
const Label = ({ children }) => (
  <label className="mb-1 block text-sm font-semibold text-slate-800">
    {children}
  </label>
);

const TextInput = (props) => (
  <input
    {...props}
    className={`w-full rounded border border-black/90 px-3 py-2 text-sm outline-none ${props.className || ""
      }`}
  />
);

const ReadonlyBar = ({ placeholder }) => (
  <div className="min-h-9 w-full text-left justify-content-start rounded bg-[#eeeeee] text-sm text-slate-500 grid items-center select-none pl-2">
    {placeholder}
  </div>
);

const SelectField = ({ children, className = "", ...props }) => (
  <div className={`relative ${className}`}>
    <select
      {...props}
      className="w-full appearance-none rounded border border-black/90 px-3 py-2 pr-8 text-sm outline-none bg-white"
    >
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-700" />
  </div>
);

const FloatingBook = ({ book, handleBookClickBookDua }) => {

  return (
    <div className="group transform transition-transform duration-300 hover:-translate-y-1 cursor-pointer">
      <img
        onClick={(e) => handleBookClickBookDua(e, book)}
        src={ resolveBookImageUrl(book.coverImage) }
        className="mx-auto h-40 w-28 rounded object-cover shadow-sm"
        alt={book?.title}
      />
      <div className="mt-2 flex items-center justify-center gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            size={12}
            className={`${i < book?.averageRating
                ? "fill-amber-400 text-amber-400"
                : "text-gray-300"
              }`}
          />
        ))}
      </div>
    </div>
  );
};
const CreateMeetup = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const titleBo = searchParams.get("title");
  const authorBo = searchParams.get("author");

  const { lg } = useContext(LanguageContext);
  const { user } = ChatState();
  const itemRefs = useRef([]);
  const { id } = useParams();

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const [modalData, setModalDate] = useState({
    image: null,
    title: "",
    writer: "",
    genre: "",
    aboutBook: "",
  });
  const handleModalInputChange = (e) => {
    const { name, value } = e.target;
    setModalDate((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [show, setShow] = useState(false); // For signup modal
  const [showB, setShowB] = useState(false); // For signup modal

  const [wShow, setWShow] = useState(false); // For signup modal

  const handleClose = () => {
    setShow(false);
  };
  const handleCloseB = () => {
    setShowB(false);
  };

  const handleCloseW = () => {
    setWShow(false);
    window.location.reload();
  };
  const handleShowW = () => {
    setWShow(true); // Open  modal
  };
  const handleShowB = () => {
    setShowB(true); // Open  modal
  };
  // Handle opening Show modal

  const handleShow = () => {
    setShow(true); // Open signup modal
  };

  const navigate = useNavigate();

  // Imag

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  const [auth, setAuth] = useAuth();

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [selectedImagemodel, setSelectedImagemodel] = useState(null);

  const [imageName, setImageName] = useState("");
  // const [selectedImage, setSelectedImage] = useState(null);
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [genre, setGenre] = useState("");
  const [uploadedImage, setUploadedImage] = useState();
  const [uploadedTitle, setUploadedTitle] = useState("");
  const [uploadedAuthor, setUploadedAuthor] = useState("");
  const [uploadedAboutBook, setUploadedAboutBook] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [uploadedGerne, setUploadedGerne] = useState("");
  const [selectedCityObj, setSelectedCityObj] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setSelectedImagemodel(fileURL);
      setImageName(file.name);

      localStorage.setItem("uploadedImagemodelaaaa", fileURL);
      localStorage.setItem("uploadedImageNamenew", file.name);
      setModalDate({ ...modalData, image: file });
    }
  };
  const handleCreateEvent = async () => {
    console.log(selectedBook, "selectedBook");

    try {
      // 1. Validate and build payload
      const payload = {
        title: selectedBook?.title,
        name: "Book Duo",
        author: selectedBook?.author,
        aboutBook: selectedBook?.aboutBook,
        pageNumber: selectedBook?.pageNumber,
        genre: selectedBook?.genre,
        age: joinedAge,
        language: selectedLanguage,
        type: eventType,
        description: eventDetails,
        userId: user?._id, // You need to get this from auth
        email: user?.email,
        city: selectedCityObj?.city, // ✅ Use from selectedCityObj
        country: selectedCityObj?.country, // ✅ Optional if needed
        lati: selectedCityObj?.latitude, // ✅ Accurate location
        langi: selectedCityObj?.longitude,
        gender: formData.gender,
        EAN: selectedBook?.id, // ✅ Ensure EAN is included
        image: modalData?.showImage
          ? modalData?.link
          : `${selectedBook?.image}`,
        ...(eventType === "In-person" && {
          location: {
            name: eventLocation,
            address: eventAddress,
            coordinates: [
              selectedCityObj?.longitude ?? 0, // ✅ longitude first
              selectedCityObj?.latitude ?? 0, // ✅ then latitude
            ],
          },
        }),
        ...(eventType === "On-line" && {
          meetingLink: eventLink,
        }),
      };

      // 2. Check for any missing required fields
      const requiredFields = {
        Title: payload.title,
        Author: payload.author,
        "Looking For": payload.gender,
        Age: payload.age,
        Language: payload.language,
        "Event Type": payload.type,
        // Description: payload.description,

        "Image URL": payload.image,
        ...(payload.type === "In-person" && {
          City: payload.city,
        }),
        ...(payload.type === "On-line" && {
          "Meeting Link": payload.meetingLink,
        }),
      };
      if (!selectedAge || !selectedMaxAge) {
        throw new Error("Missing required fields: Age");
      }
      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value)
        .map(([field]) => field);

      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      // 3. Make API call with Axios
      const response = await axios.post("api/v1/books/addbooks", payload, {
        headers: {
          "Content-Type": "application/json",
          // Add if using authentication:
          // 'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      });

      // 4. Handle success
      toast.success("Book event created successfully!");
      console.log("Created book:", response.data);
      handleShowW(true);
      setImageName("");
      localStorage.removeItem("uploadedImagemodelaaaa");

      navigate(`/`); // Uncomment if you want to redirect
    } catch (error) {
      // 5. Handle errors
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to create book event";
      toast.error(errorMessage);
      console.error("Creation error:", error);
      setIsSubmitting(false); // Reset submitting state
      // Optional: Scroll to top to show error message
      window.scrollTo(0, 0);
    }
  };
  const handleUpdateBook = async (bookId) => {
    try {
      const payload = {
        title: selectedBook?.title,
        name: "Book Duo",
        author: selectedBook?.author,
        aboutBook: selectedBook?.aboutBook,
        genre: selectedBook?.genre,
        age: joinedAge,
        language: selectedLanguage,
        type: eventType,
        description: eventDetails,
        userId: user?._id,
        email: user?.email,
        city: selectedCityObj?.city,
        country: selectedCityObj?.country,
        lati: selectedCityObj?.latitude,
        langi: selectedCityObj?.longitude,
        gender: formData.gender,
        image: modalData?.showImage ? modalData?.link : selectedBook?.image,
        ...(eventType === "In-person" && {
          location: {
            name: eventLocation,
            address: eventAddress,
            coordinates: [
              selectedCityObj?.longitude ?? 0,
              selectedCityObj?.latitude ?? 0,
            ],
          },
        }),
        ...(eventType === "On-line" && {
          meetingLink: eventLink,
        }),
      };

      // Validation
      const requiredFields = {
        Title: payload.title,
        Author: payload.author,
        Age: payload.age,
        Language: payload.language,
        "Looking For": payload.gender,
        "Event Type": payload.type,
        "Image URL": payload.image,
        ...(payload.type === "In-person" && {
          City: payload.city,
        }),
        ...(payload.type === "On-line" && {
          "Meeting Link": payload.meetingLink,
        }),
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value)
        .map(([field]) => field);

      if (missingFields.length > 0) {
        setIsSubmitting(false);
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }
      if (!selectedAge || !selectedMaxAge) {
        setIsSubmitting(false);
        throw new Error("Missing required fields: Age");
      }
      // ✅ Use PUT for update
      const response = await axios.put(
        `/api/v1/books/updatebook/${bookId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Book event updated successfully!");
      console.log("Updated event:", response.data);
      handleShowW(true);
      setImageName("");
      localStorage.removeItem("uploadedImagemodelaaaa");
      setIsSubmitting(false);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to update book event";
      toast.error(errorMessage);
      console.error("Update error:", error);
      window.scrollTo(0, 0);
      setIsSubmitting(false);
    }
  };

  // CSV SEARCH
  const [query, setQuery] = useState("");
  const [bookss, setBookss] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [eventType, setEventType] = useState(""); // State to track selected option
  const [eventLocation, setEventLocation] = useState("");
  const [eventLink, setEventLink] = useState("");
  const [eventAddress, setEventAddress] = useState("");
  const [eventDetails, setEventDetails] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  const [suggestionsCity, setSuggestionsCity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ageRanges, setAgeRanges] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedMaxAge, setSelectedMaxAge] = useState("");

  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [loadingMen, setLoadingMen] = useState(false);

  // SUGGEST BOOK 1:1
  const [headings, setHeadings] = useState([]);
  const [booksByHeading, setBooksByHeading] = useState({});
  const [book, setBook] = useState();
  const joinedAge = `${selectedAge}-${selectedMaxAge}`; // e.g. "10-16"

  useEffect(() => {
    fetchHeadings();
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/v1/books/${id}`)
        .then((res) => {
          const data = res.data;

          setBook(data); // If needed
          setSelectedBook(data);
          setSelectedGender(data?.gender);
          const [minAge, maxAge] = data.age?.split("-") || ["", ""];
          setSelectedAge(minAge);
          setSelectedMaxAge(maxAge);

          setSelectedLanguage(data.language);
          setEventType(data.type);
          setEventDetails(data.description);
          // setSelectedMonth(data.dateInfo?.month || ""); // already working

          setEventTime(
            data.timeTrack?.minutes?.toString().padStart(2, "0") || ""
          );
          // setVisibility(
          //   data.timeTrack?.seconds?.toString().padStart(2, "0") || ""
          // );

          setSearchQuery(data.city);

          setSelectedCityObj({
            city: data.city,
            country: data.country,
            latitude: data.lati,
            longitude: data.langi,
          });
          setEventLocation(data.location?.name || "");
          setEventAddress(data.location?.address || "");
          setEventLink(data.meetingLink || "");
          // setMaxValue(data.maxAttendee || "");
          // setMinValue(data.minAttendee || "");
          // setModalData({ link: data.image, showImage: true });
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const fetchHeadings = async () => {
    try {
      const response = await axios.get("api/v1/admin/getheading");
      setHeadings(response.data);
      await fetchAllBooks(response.data); // Automatically fetch books for all headings
      setLoading(false);
    } catch (error) {
      console.error("Error fetching headings:", error);
    }
  };

  const fetchAllBooks = async (headings) => {
    try {
      const response = await axios.get(`/api/v1/admin/getAllCovers`);
      console.log(response?.data?.books.length, "books by heading");

      setBooksByHeading(response?.data?.books);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };
  useEffect(() => {
    if (highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);
  const StarRating = ({ rating }) => {
    const totalStars = 5;

    return (
      <div>
        {Array.from({ length: totalStars }, (_, index) => (
          <span
            key={index}
            style={{
              fontSize: "21px",
              color: index < rating ? "#ffc107" : "#ddd", // Warning color for filled stars, light grey for empty stars
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };
  const handleBookClickBookDua = (e, book) => {
    console.log(book, "book clicked");
    const selectedBookObj = {
      bookId: book.EAN ? book.EAN : book._id, // 👈 Use book.id if available
      bookCoverImage: book.image, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book,
      EAN: book.EAN, // 👈 Add EAN if available
      isSearchBook: true, // 👈 Add this if coming from searchbook
    };

    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );
    const queryParam = book?.EAN
      ? `ean=${encodeURIComponent(book.EAN)}`
      : `bookid=${encodeURIComponent(book?._id)}`;
    navigate(`/reviews?${queryParam}`);
  };
  // SUGGEST BOOK 1:1

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch age ranges
        const ageResponse = await axios.get(`api/v1/stores/age`);
        setAgeRanges(ageResponse.data.data);

        // Fetch languages
        const langResponse = await axios.get(`api/v1/stores/lang`);
        setLanguages(langResponse.data.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleInputChangeCity = async (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value.trim() !== "") {
      try {
        const response = await axios.get(
          `/api/v1/books/books/searchCity?query=${encodeURIComponent(value)}`
        );

        if (response.data.success && Array.isArray(response.data.data)) {
          setSuggestionsCity(response.data.data); // Show city suggestions
        } else {
          setSuggestionsCity([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestionsCity([]);
      }
    } else {
      setSuggestionsCity([]); // Reset suggestions when input is empty
    }
  };

  const handleSuggestionClick = (cityObj) => {
    console.log("Selected city:", cityObj.city);
    console.log("Selected country:", cityObj.country);

    setCity(cityObj.city); // Set the selected city
    setCountry(cityObj.country); // Set the selected country
    setSearchQuery(`${cityObj.city}, ${cityObj.country}`); // Set searchQuery to both city and country
    setSelectedCityObj(cityObj);
    setSuggestions([]); // Hide suggestions after selection
    setSuggestionsCity([]);
  };

  const handleSearch = async () => {
    if (!query) return;

    setLoading(true);
    setError("");

    try {
      const res = await axios.get(`api/search?query=${query}`);
      console.log("📡 API Response:", res.data); // ✅ Debugging
      setBookss(res.data.books || []); // ✅ Correct key
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching books");
      setBookss([]);
    }

    setLoading(false);
  };
  const handleSuggestionClickName = (book) => {
    const selectedBookObj = {
      bookId: undefined, // 👈 Use book.id if available
      bookCoverImage: book.image, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book,
      EAN: book.id, // 👈 Add EAN if available
      isSearchBook: true, // 👈 Add this if coming from searchbook
    };

    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );
    navigate(`/reviews?ean=${book.id}&searchbook=true`);
  };
  useEffect(() => {
    console.log("📚 Updated Books State:", bookss); // ✅ Debugging
  }, [bookss]);

  const [startIndex, setStartIndex] = useState(0);
  const booksPerPage = 1;

  const showNextBooks = () => {
    setStartIndex((prev) => prev + booksPerPage);
  };
  // CSV SEARCH

  const [selectedBook, setSelectedBook] = useState(null);

  // ✅ Load data from LocalStorage when page loads
  useEffect(() => {
    const savedBook = localStorage.getItem("selectedBookaaaa");
    if (savedBook) {
      setSelectedBook(JSON.parse(savedBook));
    }
  }, []);

  useEffect(() => {
    console.log("Final Book Data Title:", uploadedTitle);
  }, [uploadedTitle]);
  // const handleButtonClick = () => {
  //   fileInputRef.current.click(); // ✅ Click to upload new image
  // };

  // SAVE IN DATBASE
  const [formData, setFormData] = useState({
    city: "",
    language: "",
    age: "",
    type: "",
    description: "",
    gender: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedBook) {
      toast.error("Please select a book first!");
      return;
    }

    const finalBookData = selectedBook
      ? {
        title: uploadedTitle || selectedBook["Title Derived"],
        author: uploadedAuthor || selectedBook["First Contributor Name"],
        aboutBook: uploadedAboutBook || selectedBook["AboutBook"],

        pageNumber: uploadedGerne || selectedBook["Page Number"],
        image: selectedBook.image
          ? selectedBook.image
          : selectedBook.EAN
            ? `${selectedBook.EAN}.jpg`
            : "", // ✅ Image filename
        city: formData.city,
        language: formData.language,
        type: formData.type,
        age: formData.age,
        gender: formData.gender,

        description: formData.description,
      }
      : {
        image: uploadedImage || selectedImage || "", // ✅ Ensure uploaded image is used correctly
        title: uploadedTitle || "Untitled",
        author: uploadedAuthor || "Unknown",
        aboutBook: uploadedAboutBook || "Unknown",

        genre: uploadedGerne || "N/A",
      };

    try {
      const response = await axios.post("api/v1/books/addbooks", finalBookData);
      toast.success(response.data.message);
      handleShowW(true);
      localStorage.removeItem("selectedBookaaaa");
      // window.location.reload();
      localStorage.removeItem("checkbox1State");
      localStorage.removeItem("checkbox2State");
      localStorage.removeItem("checkbox3State");
      localStorage.removeItem("uploadedImageNamenew");
    } catch (error) {
      // console.error("Error adding book:", error);
      toast.error(error.response.data.message);
    }
  };
  // SAVE IN DATBASE

  const [selectedGender, setSelectedGender] = useState("");
  const handleCheckboxChange2 = (gender) => {
    setSelectedGender(gender); // Sirf ek gender select ho sakta hai
  };

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const fetchSuggestions = async (searchQuery) => {
    if (!searchQuery.trim()) {
      setSuggestions([]);
      return;
    }
    setModalDate({ showImage: false });
    setLoading(true);
    try {
      const res = await axios.get(
        `api/search?query=${encodeURIComponent(searchQuery)}`
      );
      // Map the API response to match your data structure
      const formattedBooks = res.data?.books?.map((book) => ({
        id: book.EAN,
        title: book["Title Derived"],
        author: book["First Contributor Name"],
        format: book["Product Form Description"],
        publisher: book["Publisher Imprint"],
        genre: book["1st BISAC Major Description"],
        aboutBook: book["AboutBook"],
        pageNumber: book["Page Number"],
        image: book.image,
      }));

      if (titleBo) {
        // handleBookClick(formattedBooks[0]);
      } else {
        setSuggestions(formattedBooks);
        setShowSuggestions(true);
      }
    } catch (err) {
      console.error("Search error:", err);
      setSuggestions([]);
    }
    setLoading(false);
  };
  const searchEvents = async (query) => {
 
  try {
    const res = await axios.get(`/api/v1/books/search-by-title`, {
      params: { q: query },
    });
 const books = res.data.results || [];

    // Filter only books from the selected author
    const filteredByAuthor = books.filter(
      (book) =>
        book["First Contributor Name"]?.toLowerCase() ===
        authorBo.toLowerCase()
    );
     const formattedBooks = filteredByAuthor?.map((book) => ({
      id: book.EAN,
      title: book["Title Derived"],
      author: book["First Contributor Name"],
      format: book["Product Form Description"],
      publisher: book["Publisher Imprint"],
      genre: book["1st BISAC Major Description"],
      aboutBook: book["AboutBook"],
      pageNumber: book["Page Number"],
      image: book.image,
     }));
    handleBookClick(formattedBooks[0])
   console.log(res.data.results, "search by title",formattedBooks);
  } catch (err) {
    console.error(err);
  }
};
  useEffect(() => {
    if (titleBo) {
      searchEvents(titleBo);
    }
  }, [titleBo]);
  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      fetchSuggestions(value);
    }, 300);
  };

  const handleBookClick = (book) => {
    // Save the complete book data to localStorage
    console.log("Book clicked:", book);
    setSelectedBook(book);
    setQuery(book.title);
    setShowSuggestions(false);
    // Optional: Trigger any parent component callback or state update
  };
  // Frontend API call example
  const addBookManually = async () => {
    setSelectedBook({
      title: modalData.title,
      author: modalData.writer,
      genre: modalData.genre,
      aboutBook: modalData.aboutBook || "",
    });

    const formData = new FormData();

    // Append text fields
    formData.append("title", modalData.title);
    formData.append("writer", modalData.writer);
    formData.append("genre", modalData.genre);
    formData.append("description", modalData.aboutBook || "");

    // Append image if exists
    if (modalData.image) {
      formData.append("image", modalData.image);
    }

    try {
      const response = await axios.post("api/v1/books/manual-add", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
          // Add if using authentication:
          // "Authorization": `Bearer ${localStorage.getItem('token')}`
        },
      });
      console.log(response, "ddd");

      setModalDate({
        image: null,
        title: "",
        writer: "",
        genre: "",
        aboutBook: "",
        showImage: true,
        link: response.data?.data.coverImage, // Assuming API returns coverImage in response
      });

      handleCloseB();
      return response.data;
    } catch (error) {
      console.error("Error adding book:", error);

      // Enhanced error handling
      let errorMessage = "Failed to add book";
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || errorMessage;

        // Handle validation errors if available
        if (error.response.data?.errors) {
          errorMessage = Object.values(error.response.data.errors).join("\n");
        }
      } else if (error.request) {
        // Request was made but no response
        errorMessage = "Network error - please check your connection";
      }

      // Show pretty toast notification
      toast.error(errorMessage);
    }
  };

  if (loadingMen) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <div className="createmeetup booksandreviewsheader">
        {/* {!auth?.user ? <Header4 /> : <Header3 />} */}
        <Header3 />
      </div>
      <div className="alincenterawidth scalmddin1 d-none">
        <div className="d-xl-flex flex-wrap justify-content-center  ">
          <div className="col-xl-7 mt-4 d-flex justify-content-center mllmeet mb-5">
            <div className="mx-md-4 mx-3 mxclintbok">
              <div
                className="text-dark mx-md-5  wolcom mx-sm-4 mx-2 fw-bold"
                style={{ fontSize: "26px", lineHeight: "43.58px" }}
              >
                {/* Your Book Duo */}
                {lg?.yourbd}
              </div>

              <div className="d-flex mt-4 ">
                <div className="text-dark ftzevtt fw600 fs-5 col-sm-2 col-3 mx-md-5 mx-sm-4 d-none d-sm-block mlcreall "></div>

                <div className="relative mwcserduo" style={{ width: "350px" }}>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      // placeholder="Search book..."
                      placeholder={lg?.serchbook}
                      value={query}
                      onChange={handleInputChange}
                      onFocus={() => setShowSuggestions(true)}
                      onBlur={() =>
                        setTimeout(() => setShowSuggestions(false), 200)
                      }
                      style={{
                        height: "41px",
                        border: "2px solid #3C3C3C",
                        borderRadius: "4px",
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "ArrowDown") {
                          setHighlightedIndex((prev) =>
                            prev < suggestions.length - 1 ? prev + 1 : 0
                          );
                        } else if (e.key === "ArrowUp") {
                          setHighlightedIndex((prev) =>
                            prev > 0 ? prev - 1 : suggestions.length - 1
                          );
                        } else if (e.key === "Enter" && highlightedIndex >= 0) {
                          handleBookClick(suggestions[highlightedIndex]);
                          setShowSuggestions(false);
                        }
                      }}
                    />
                  </InputGroup>

                  {showSuggestions && (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        maxHeight: "300px",
                        maxWidth: "350px",
                        overflowY: "auto",
                        backgroundColor: "white",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        zIndex: 1000,
                        marginTop: "5px",
                      }}
                      className="mwcserduo"
                    >
                      {loading ? (
                        <div className="p-2 text-muted">Loading...</div>
                      ) : suggestions.length > 0 ? (
                        suggestions.map((book, index) => {

                          return (
                            <div
                              key={book.id}
                              ref={(el) => (itemRefs.current[index] = el)} // Assign ref
                              style={{
                                padding: "8px 12px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                display: "flex",
                                alignItems: "center",
                                backgroundColor:
                                  index === highlightedIndex
                                    ? "#34C3C9"
                                    : "transparent",
                              }}
                              onClick={() => handleBookClick(book)}
                            >
                              {book.image && (
                                <img
                                  src={
                                     resolveBookImageUrl(book.image)
                                  }
                                  alt={book.title}
                                  style={{
                                    width: "30px",
                                    height: "45px",
                                    objectFit: "cover",
                                    marginRight: "10px",
                                  }}
                                />
                              )}
                              <div>
                                <div style={{ fontWeight: "bold" }}>
                                  {book.title}
                                </div>
                                <div
                                  style={{ fontSize: "0.8rem", color: "#666" }}
                                >
                                  {book.author} • {book.publisher}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : query ? (
                        <div className="p-2 text-muted">No results found</div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              <div
                className="text-decoration-underline d-flex justify-content-center mt-1 mxdeatil mxdetzero mxx-md-5 mxx-sm-4  mx-2 text-primary"
                onClick={handleShowB}
                style={{ cursor: "pointer" }}
              >
                {/* Did not find your book? Enter details! */}
                {lg?.DidText}
              </div>

              <div className="containerr mt-4">
                {/* ✅ Selected Book Details Section (ALWAYS VISIBLE) */}
                <div className="d-flex mt-4">
                  {/* ✅ Image Box (HAMESHA VISIBLE RAKHNA) */}
                  <div
                    className="col-sm-2 col-3 imgbgwid mxrnone mx-md-5 mx-sm-4 mx-2 w-100"
                    style={{
                      backgroundColor: "#EAEAEA",
                      maxWidth: "111px",
                      height: "170px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",

                      overflow: "hidden", // Ensures th
                    }}
                  >
                    {selectedBook?.image || modalData?.showImage ? (
                      <img
                        onClick={() => handleSuggestionClickName(selectedBook)}
                        src={
                          modalData?.showImage
                            ? selectedImagemodel
                              : resolveBookImageUrl(selectedBook?.image)
                        }

                        alt={
                          modalData?.showImage
                            ? selectedImagemodel
                            : resolveBookImageUrl(selectedBook?.image)
                        }
                        style={{
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                          objectFit: "cover", // Ensures the image covers the container without distortion
                        }}
                      //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
                      />
                    ) : (
                      <div className="text-muted p-3 text-center"></div>
                    )}
                  </div>

                  {/* ✅ Input Fields */}
                  <div className="mlcreat">
                    {/* ✅ Book Title */}
                    <div>
                      <input
                        type="text"
                        className="form-control border-0 widmeetupin fw-bold fs-5 ftzevtt rounded-1 placeholder-login"
                        value={selectedBook?.title || ""}
                        readOnly
                        style={{
                          backgroundColor: "#EAEAEA",
                          width: "350px",
                          height: "38px",
                        }}
                      />
                    </div>

                    {/* ✅ First Contributor Name */}
                    <div className="mt-4">
                      <input
                        type="text"
                        className="form-control border-0 widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                        value={selectedBook?.author || ""}
                        readOnly
                        style={{
                          backgroundColor: "#EAEAEA",
                          width: "350px",
                          height: "38px",
                        }}
                      />
                    </div>

                    {/* ✅ Page Number */}
                    <div className="mt-4">
                      <input
                        type="text"
                        className="form-control border-0 widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                        value={selectedBook?.genre || ""}
                        readOnly
                        style={{
                          backgroundColor: "#EAEAEA",
                          width: "350px",
                          height: "38px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex mt-3 ">
                <div
                  className="text-dark fw600  fs-18 ftzevtt col-sm-2 col-3 mx-md-5 mx-sm-4 mx-2 mlcreall"
                  style={{ alignSelf: "center" }}
                >
                  {/* Type: */}
                  {lg?.type}:
                </div>
                <div className="d-sm-flex">
                  <div className="">
                    <Form.Select
                      className="form-control  widmeetupin text-dark fw600 fs-6 ftzevtt rounded-1 placeholder-login"
                      id="visibilitySelect"
                      value={eventType}
                      onChange={(e) => setEventType(e.target.value)}
                      style={{
                        // border: "2px solid #3C3C3C",
                        width: "350px",
                        height: "40px",
                      }}
                      name="type"
                    >
                      <option value=""></option>
                      <option value="In-person">{lg?.inPerson || "In-person"}</option>
                      <option value="On-line">On-line </option>
                    </Form.Select>
                  </div>

                  <div className="  d-none gap-md-1 mx-md-4 mx-sm-2">
                    <div
                      className="fw-normal text-decoration-underline ftzevtt widd fs-18  my-1  "
                      style={{
                        color: "#34C3C6",
                        width: "140px",
                        cursor: "pointer",
                      }}
                      onClick={handleShow}
                    >
                      See Suggestions
                    </div>
                    <img
                      className="my-2 "
                      src={require("../pages/image/arrowiconleft.png")}
                      width="24"
                      height="24"
                      onClick={handleShow}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>

              {eventType === "In-person" && (
                <div className="d-flex  flex-wrap mt-xxl-4  mt-lg-3 mt-sm-3 mt-2   ">
                  <div
                    className="text-dark fw600  fs-18 ftzevtt col-sm-2 col-3 mx-md-5 mx-sm-4 mx-2 mlcreall"
                    style={{ alignSelf: "center" }}
                  >
                    {/* Type: */}
                  </div>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control widmeetupin  fs-5 ftzevtt rounded-1 placeholder-login"
                      id="cityOrZipInput"
                      placeholder={lg?.city || "City"}
                      value={searchQuery}
                      onChange={handleInputChangeCity}
                      required
                      style={{
                        width: "350px",
                        height: "32px",
                        color: "#767676",
                      }}
                    />

                    {isLoading && (
                      <div className="position-absolute top-100 start-0 mt-1">
                        <div
                          className="spinner-border text-primary spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}

                    {suggestionsCity.length > 0 && (
                      <ul
                        className="list-group position-absolute top-100 start-0 mt-1 z-3"
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        }}
                      >
                        {suggestionsCity?.map((suggestion, index) => (
                          <li
                            key={index}
                            className="list-group-item list-group-item-action py-2 px-3"
                            style={{ cursor: "pointer", fontSize: "14px" }}
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            {suggestion.city},{suggestion.country}
                            {/* Adjust based on your API response structure */}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  {/* <div className="">
                    <input
                      type="text"
                      className="form-control widmeetupin  fs-5 ftzevtt rounded-1 placeholder-login"
                      id="text"
                      value={eventLocation}
                      placeholder="Location"
                      onChange={(e) => setEventLocation(e.target.value)}
                      required
                      style={{
                        width: "162px",
                        height: "32px",
                        color: "#767676",
                      }}
                    />
                  </div>

                  <div className="">
                    <input
                      type="text"
                      className="form-control widmeetupin  fs-5 ftzevtt rounded-1 placeholder-login"
                      id="text"
                      placeholder="Address"
                      value={eventAddress}
                      onChange={(e) => setEventAddress(e.target.value)}
                      required
                      style={{
                        width: "162px",
                        height: "32px",
                        color: "#767676",
                      }}
                    />
                  </div> */}
                </div>
              )}
              {eventType === "On-line" && (
                <div className="d-flex flex-wrap mt-xxl-4  mt-lg-3 mt-sm-3 mt-2   ">
                  <div
                    className="text-dark fw600  fs-18 ftzevtt col-sm-2 col-3 mx-md-5 mx-sm-4 mx-2 mlcreall"
                    style={{ alignSelf: "center" }}
                  >
                    {/* Type: */}
                  </div>
                  <div className="">
                    <input
                      type="text"
                      className="form-control widmeetupin border-dark  fs-6 ftzevtt rounded-1 placeholder-login"
                      id="text"
                      // placeholder="Add link to the video call (Teams, Zoom, Google Meet, Skype etc.) "
                      placeholder={lg?.onlink}
                      value={eventLink}
                      onChange={(e) => setEventLink(e.target.value)}
                      required
                      style={{
                        width: "350px",
                        height: "32px",
                        color: "#767676",
                      }}
                    />
                  </div>
                </div>
              )}
              <div className="d-flex mt-3 ">
                <div className="text-dark fw600 ftzevtt col-sm-2 col-3 fs-18 mx-md-5 mx-sm-4 mx-2 mlcreall">
                  {/* Looking for: */}
                  {lg?.lookigfr}:
                </div>

                <div className=" d-flex flex-wrap gap-sm-4  gap-2 align-self-center">
                  <div className="mx-sm-4  mx-md-0">
                    <label
                      className="form-check-label  text-dark ftzevtt fw600 "
                      htmlFor="flexCheckDefault1"
                      style={{
                        fontSize: "18px",

                        lineHeight: "18.51px",
                      }}
                    >
                      {/* Male */}
                      {lg?.male}
                    </label>
                    <input
                      className="form-check-input rounded-0 boxsize mt-1 mx-2 placeholder-login"
                      type="checkbox"
                      value="Male"
                      name="gender"
                      checked={selectedGender === "Male"}
                      onChange={(e) => {
                        handleCheckboxChange2("Male"); // 🔹 Pehla function
                        handleChange(e); // 🔹 Dusra function
                      }}
                      defaultValue
                      id="flexCheckDefault1"
                      style={{ border: "1px solid #000000 " }}
                    />
                  </div>

                  <div>
                    <label
                      className="form-check-label text-dark ftzevtt fw600 "
                      htmlFor="flexCheckDefault2"
                      style={{
                        fontSize: "18px",

                        lineHeight: "18.51px",
                      }}
                    >
                      {/* Female */}
                      {lg?.female}
                    </label>
                    <input
                      className="form-check-input rounded-0 mt-1 boxsize mx-2 placeholder-login"
                      type="checkbox"
                      name="gender"
                      value="Female"
                      checked={selectedGender === "Female"}
                      onChange={(e) => {
                        handleCheckboxChange2("Female"); // 🔹 Pehla function
                        handleChange(e); // 🔹 Dusra function
                      }}
                      defaultValue
                      id="flexCheckDefault2"
                      style={{ border: "1px solid #000000 " }}
                    />
                  </div>

                  <div>
                    <label
                      className="form-check-label text-dark ftzevtt fw600 "
                      htmlFor="flexCheckDefault3"
                      style={{
                        fontSize: "18px",

                        lineHeight: "18.51px",
                      }}
                    >
                      {/* I don’t care */}
                      {lg?.idk}
                    </label>
                    <input
                      className="form-check-input rounded-0 boxsize mt-1 mx-2 placeholder-login"
                      type="checkbox"
                      name="gender"
                      value="I don’t care" // ✅ Add value
                      checked={selectedGender === "I don’t care"}
                      onChange={(e) => {
                        handleCheckboxChange2("I don’t care"); // 🔹 Pehla function
                        handleChange(e); // 🔹 Dusra function
                      }}
                      defaultValue
                      id="flexCheckDefault3"
                      style={{ border: "1px solid #000000 " }}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex mt-3 ">
                <div className="text-dark fw600 ftzevtt col-sm-2 col-3 fs-18 mx-md-5 mx-sm-4 mx-2 mlcreall">
                  {/* Age range: */}
                  {lg?.agerg}:
                </div>

                <div className="widust d-flex flex-wrap gap-4">
                  <Form.Select
                    className="form-control widboxbokd border-dark py-0 text-dark fs-5 ftzevtt rounded-1 placeholder-login"
                    value={selectedAge}
                    onChange={(e) => setSelectedAge(e.target.value)}
                    style={{
                      width: "100px",
                      border: "2px solid #3C3C3C",
                      height: "32px",
                    }}
                  >
                    <option value="">{lg?.min || "Min"}</option>
                    {Array.from({ length: 90 - 18 + 1 }, (_, i) => {
                      const age = i + 18;
                      return (
                        <option key={age} value={age}>
                          {age}
                        </option>
                      );
                    })}
                  </Form.Select>
                  <Form.Select
                    className="form-control widboxbokd border-dark py-0 text-dark fs-5 ftzevtt rounded-1 placeholder-login"
                    value={selectedMaxAge}
                    onChange={(e) => setSelectedMaxAge(e.target.value)}
                    style={{
                      width: "100px",
                      border: "2px solid #3C3C3C",
                      height: "32px",
                    }}
                  >
                    <option value="max">{lg?.max || "Max"}</option>

                    <option value="no-limit">No Limit</option>
                    {[...Array(90)]
                      .map((_, i) => i + 2)
                      .filter((val) => val > selectedAge) // ✅ Only show Max > Min
                      .map((val) => (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      ))}
                  </Form.Select>
                </div>
              </div>

              <div className="d-flex mt-3 ">
                <div className="text-dark fw600 ftzevtt fs-18 col-sm-2 col-3 mx-md-5 mx-sm-4 mx-2 mlcreall">
                  {/* Language: */}
                  {lg?.language}:
                </div>

                <div className="">
                  <Form.Select
                    className="form-control py-0 widmeetupin text-dark fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                    id="visibilitySelect"
                    value={selectedLanguage}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                    style={{
                      border: "2px solid #3C3C3C",
                      width: "350px",
                      height: "40px",
                    }}
                    name="age" // Add this
                  >
                    <option value=""></option>
                    {languages.map((language) => (
                      <option key={language?._id} value={language?.code}>
                        {language?.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div
                  className="tooltip-container mt-2 ms-2"
                  style={{ position: "relative" }}
                >
                  <span
                    className=""
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <BsQuestionCircleFill size={20} />
                  </span>
                  <div className="custom-tooltip">
                    This is the language participants will speak during Book
                    Duo.
                  </div>
                </div>
              </div>

              <div className="d-flex mt-3 ">
                <div className="text-dark fw600 ftzevtt col-sm-2 col-3 fs-18 mx-md-5 mx-sm-4 mx-2 mlcreall">
                  {/* Details: */}
                  {lg?.detil}:
                </div>

                <div className="">
                  <textarea
                    type="text"
                    className="form-control textacre widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                    id="text"
                    required
                    name="description"
                    value={eventDetails}
                    onChange={(e) => setEventDetails(e.target.value)}
                    placeholder={lg?.eventDetails || "Enter event details..."}
                    style={{
                      border: "2px solid #3C3C3C",
                      width: "350px",
                      height: "150px",
                    }}
                  />
                </div>
                <div className="fw-normal ftzevtt d-sm-block d-none  my-1 fs-5 text-dark  mx-4">
                  {/* Optional */}
                  {lg?.optnal}
                </div>
              </div>

              <div className="d-flex justify-content-center mt-5 mlsubcret">
                <button
                  className="text-white subbtnmeet border-0 fs-18 fw600 rounded-1"
                  style={{
                    width: "135px",
                    height: "44px",
                    backgroundColor: "#62C0C7",
                  }}
                  // onClick={handleShowW}
                  onClick={async () => {
                    if (isSubmitting) return; // Prevent double click
                    setIsSubmitting(true);

                    try {
                      if (id) {
                        await handleUpdateBook(id);
                      } else {
                        await handleCreateEvent();
                      }
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {/* Submit */}
                  {isSubmitting ? (
                    id ? (
                      <Spinner animation="border" role="status"></Spinner>
                    ) : (
                      <Spinner animation="border" role="status"></Spinner>
                    )
                  ) : id ? (
                    "Update"
                  ) : (
                    lg?.publsbtn
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="col-xl-5 d-flex sclnone1">
            <div
              className=" widbgcol bgcoolsl mrlla w-100"
              style={{
                backgroundColor: "#EAEAEA",
                maxWidth: "100%",
                height: "auto",
              }}
              onClick={() => navigate("/suggestivebooks")}
            >
              <div
                className="fw-bold wolcom text-dark mx-4 mt-4"
                style={{ fontSize: "26px", lineHeight: "40.85px" }}
              >
                {/* Looking for Inspiration */}
                {lg?.lookiginsp}
              </div>
              <div className="mx-4 fw600 ftlink fs-22 my-3 text-dark ">
                {/* Suggested books for a 1:1 */}
                {lg?.suggbokduo}
              </div>

              <div className="d-flex flex-wrap mx-4 mlmrnone gap-3 mt-5">
                <div>
                  {loading ? (
                    <p className="text-center" style={{}}>
                      Loading Books...
                    </p>
                  ) : (
                    <div className="d-flex  justzomag11  gap-xl-2 gap-1 align-items-center">
                      <div className="d-flex flex-wrap jucfyy  gapbooks ">
                        {booksByHeading.length > 0 ? (
                          booksByHeading.map((book) => (
                            <Card
                              key={book?._id}
                              className="border-0 align-items-center cursor-pointer"
                              style={{
                                width: "",
                                backgroundColor: "transparent",
                                cursor: "pointer",
                              }}
                            >
                              <Card.Img
                                className="imgsizeddddd cursor-pointer"
                                variant="top"
                                src={`${BASE_URL}/uploadsbook/${book.coverImage}`}
                                style={{
                                  width: "100px",
                                  height: "140px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handleBookClickBookDua(e, book)}
                              />
                              <Card.Body
                                className="p-0"
                                style={{ marginTop: "-30px" }}
                              >
                                <div>
                                  <span
                                    className="mx-2"
                                    style={{ fontSize: "21px" }}
                                  >
                                    <StarRating rating={book?.averageRating} />
                                  </span>
                                </div>
                              </Card.Body>
                            </Card>
                          ))
                        ) : (
                          <p>
                            No books found under this Suggested books for a 1:1.
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div
                className="mt-5 mb-4 pt-md-5 fs-18 fw-normal text-decoration-underline ftzevtt text-center"
                style={{ color: "#34C3C6", cursor: "pointer" }}
                onClick={() => navigate("/suggestivebooks")}
              >
                {/* See more suggestions */}
                {lg?.seemoresugg}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 lg:!px-0 py-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_380px]">
            {/* Left: form card */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8">
              <h1 className="mb-6 text-2xl md:text-3xl font-bold text-gray-900">
                {lg?.yourbd || "Your Book Duo"}
              </h1>

              {/* Book search */}
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.serchbook || "Search book"}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder={lg?.serchbook || "Search book..."}
                    value={query}
                    onChange={handleInputChange}
                    onFocus={() => setShowSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                    onKeyDown={(e) => {
                      if (e.key === "ArrowDown") {
                        setHighlightedIndex((prev) =>
                          prev < suggestions.length - 1 ? prev + 1 : 0
                        );
                      } else if (e.key === "ArrowUp") {
                        setHighlightedIndex((prev) =>
                          prev > 0 ? prev - 1 : suggestions.length - 1
                        );
                      } else if (e.key === "Enter" && highlightedIndex >= 0) {
                        handleBookClick(suggestions[highlightedIndex]);
                        setShowSuggestions(false);
                      }
                    }}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                  />
                  {showSuggestions && (
                    <div className="absolute w-full mt-1 max-h-80 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                      {loading ? (
                        <div className="p-3 text-gray-500 text-center">{lg?.loading || "Loading..."}</div>
                      ) : suggestions.length > 0 ? (
                        suggestions.map((book, index) => (
                          <div
                            key={book.id}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={`flex items-center gap-3 p-3 cursor-pointer border-b border-gray-100 last:border-b-0 hover:bg-gray-50 ${
                              index === highlightedIndex ? "bg-[#34C3C9] text-white" : ""
                            }`}
                            onClick={() => handleBookClick(book)}
                          >
                            {book.image && (
                              <img
                                  src={resolveBookImageUrl(book.image)
                                }
                                alt={book.title}
                                className="w-8 h-12 object-cover rounded"
                              />
                            )}
                            <div className="flex-1 min-w-0">
                              <div className="font-semibold truncate">{book.title}</div>
                              <div className="text-sm text-gray-600 truncate">
                                {book.author} • {book.publisher}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : query ? (
                        <div className="p-3 text-gray-500 text-center">{lg?.noResultsFound || "No results found"}</div>
                      ) : null}
                    </div>
                  )}
                </div>
                <button
                  className="mt-2 text-sm text-[#34C3C9] hover:text-[#2BB3BA] underline transition-colors"
                  onClick={handleShowB}
                >
                  {lg?.DidText || "Did not find your book? Enter details!"}
                </button>
              </div>

              {/* Cover + readonly bars */}
              <div className="mb-6 flex flex-col sm:flex-row gap-4">
                {/* Book Cover */}
                <div className="w-full max-w-[180px] mx-auto sm:mx-0 flex-shrink-0">
                  <div className="bg-gray-100 rounded-xl shadow-sm border border-gray-200 w-full aspect-[2/3] flex items-center justify-center overflow-hidden relative">
                    {selectedBook?.image || modalData?.showImage ? (
                      <img
                        onClick={() => handleSuggestionClickName(selectedBook)}
                        src={
                          modalData?.showImage
                            ? selectedImagemodel
                            : resolveBookImageUrl(selectedBook?.image)
                        }
                        alt={selectedBook?.title || "Book cover"}
                        className="w-full h-full object-cover cursor-pointer"
                      />
                    ) : (
                      <div className="text-gray-400 text-center p-6">
                        <svg className="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                        </svg>
                        <p className="text-sm">{lg?.noBookSelected || "No book selected"}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Book Info (Read-only) */}
                <div className="flex-1 space-y-3">
                  <input
                    type="text"
                    value={selectedBook?.title || ""}
                    readOnly
                    className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-700 font-semibold"
                  />
                  <input
                    type="text"
                    value={selectedBook?.author || ""}
                    readOnly
                    className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-700 font-medium"
                  />
                  <input
                    type="text"
                    value={selectedBook?.genre || ""}
                    readOnly
                    className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-700 font-medium"
                  />
                </div>
              </div>

              {/* Form Fields Grid */}
              <div className="space-y-6">
                {/* Type field with conditional fields directly below */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {lg?.type || "Type"}
                  </label>
                  <div className="relative">
                    <select
                      value={eventType}
                      onChange={(e) => setEventType(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value=""></option>
                      <option value="In-person">{lg?.inPerson || "In-person"}</option>
                      <option value="On-line">On-line</option>
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  
                  {/* Location/City - Appears directly below Type on mobile */}
                  {eventType === "In-person" && (
                    <div className="mt-4">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        {lg?.city || "City"}
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          placeholder={lg?.city || "City"}
                          value={searchQuery}
                          onChange={handleInputChangeCity}
                          required
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                        />
                        {isLoading && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <div className="spinner-border text-primary spinner-border-sm" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        )}
                        {suggestionsCity.length > 0 && (
                          <ul className="absolute w-full mt-1 max-h-48 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                            {suggestionsCity?.map((suggestion, index) => (
                              <li
                                key={index}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-50 border-b border-gray-100 last:border-b-0 text-sm"
                                onClick={() => handleSuggestionClick(suggestion)}
                              >
                                {suggestion.city}, {suggestion.country}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Meeting Link - Appears directly below Type on mobile */}
                  {eventType === "On-line" && (
                    <div className="mt-4">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        {lg?.meetingLink || "Meeting Link"}
                      </label>
                      <input
                        type="text"
                        placeholder={lg?.onlink || "Add link to the video call (Teams, Zoom, Google Meet, Skype etc.)"}
                        value={eventLink}
                        onChange={(e) => setEventLink(e.target.value)}
                        required
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                      />
                    </div>
                  )}
                </div>

                {/* Other fields in grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Looking for */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.lookigfr || "Looking for"}
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-[#34C3C9] focus:ring-[#34C3C9]"
                          name="gender"
                          value="Male"
                          checked={selectedGender === "Male"}
                          onChange={(e) => {
                            handleCheckboxChange2("Male");
                            handleChange(e);
                          }}
                        />
                        <span className="text-sm text-gray-700">{lg?.male || "Male"}</span>
                      </label>
                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-[#34C3C9] focus:ring-[#34C3C9]"
                          name="gender"
                          value="Female"
                          checked={selectedGender === "Female"}
                          onChange={(e) => {
                            handleCheckboxChange2("Female");
                            handleChange(e);
                          }}
                        />
                        <span className="text-sm text-gray-700">{lg?.female || "Female"}</span>
                      </label>
                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-[#34C3C9] focus:ring-[#34C3C9]"
                          name="gender"
                          value="I don't care"
                          checked={selectedGender === "I don't care"}
                          onChange={(e) => {
                            handleCheckboxChange2("I don't care");
                            handleChange(e);
                          }}
                        />
                        <span className="text-sm text-gray-700">{lg?.idk || "I don't care"}</span>
                      </label>
                    </div>
                  </div>

                  {/* Age range */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.agerg || "Age Range"}
                    </label>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="relative">
                        <select
                          value={selectedAge || ""}
                          onChange={(e) => setSelectedAge(e.target.value)}
                          className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                          style={{ paddingRight: "2.5rem" }}
                        >
                          <option value="">{lg?.min || "Min"}</option>
                          {Array.from({ length: 90 - 18 + 1 }, (_, i) => {
                            const age = i + 18;
                            return (
                              <option key={age} value={age}>
                                {age}
                              </option>
                            );
                          })}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                      </div>
                      <div className="relative">
                        <select
                          value={selectedMaxAge || ""}
                          onChange={(e) => setSelectedMaxAge(e.target.value)}
                          className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                          style={{ paddingRight: "2.5rem" }}
                        >
                          <option value="">{lg?.max || "Max"}</option>
                          <option value="no-limit">{lg?.noLimit || "No Limit"}</option>
                          {[...Array(90)]
                            .map((_, i) => i + 2)
                            .filter((val) => {
                              const minAge = parseInt(selectedAge);
                              if (isNaN(minAge)) return true;
                              return val > minAge;
                            })
                            .map((val) => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                      </div>
                    </div>
                  </div>

                  {/* Language */}
                  <div>
                    <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                      {lg?.language || "Language"}
                      <div className="relative group">
                        <BsQuestionCircleFill className="text-gray-400 cursor-help" size={14} />
                        <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                          {lg?.languageTooltip || "This is the language participants will speak during Book Duo."}
                        </div>
                      </div>
                    </label>
                    <div className="relative">
                      <select
                        value={selectedLanguage || ""}
                        onChange={(e) => setSelectedLanguage(e.target.value)}
                        className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                        style={{ paddingRight: "2.5rem" }}
                      >
                        <option value="">{lg?.selectLanguage || "Select Language"}</option>
                        {languages.map((language) => (
                          <option key={language?._id} value={language.code}>
                            {language.name}
                          </option>
                        ))}
                      </select>
                      <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                    </div>
                  </div>
                </div>

                {/* Details */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {lg?.detil || "Details"} <span className="font-normal text-gray-500">(Optional)</span>
                  </label>
                  <textarea
                    value={eventDetails}
                    onChange={(e) => setEventDetails(e.target.value)}
                    rows={4}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 resize-none"
                    placeholder={lg?.eventDetails || "Enter event details..."}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={async () => {
                    if (isSubmitting) return;
                    setIsSubmitting(true);
                    try {
                      if (id) {
                        await handleUpdateBook(id);
                      } else {
                        await handleCreateEvent();
                      }
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  disabled={isSubmitting}
                  className="px-8 py-3 bg-[#34C3C9] text-white font-semibold rounded-lg hover:bg-[#2BB3BA] transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <Spinner animation="border" size="sm" className="text-white" />
                      <span>{id ? (lg?.updating || "Updating...") : (lg?.publishing || "Publishing...")}</span>
                    </>
                  ) : id ? (
                    lg?.update || "Update"
                  ) : (
                    lg?.publsbtn || "Publish"
                  )}
                </button>
              </div>
            </div>

          {/* Right: inspiration grey card */}
          <aside className="rounded-3xl bg-[#f3f5f6] p-6 shadow-sm ring-1 ring-[#e4e4e4]">
            <h2 className="text-xl font-semibold"> {lg?.lookiginsp}</h2>
            <p className="mt-1 text-sm text-slate-600">{lg?.suggbokduo}</p>

            <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-2">
              {booksByHeading.length > 0 ? (
                booksByHeading.map((book) => (
                  <>
                    <div>
                      <FloatingBook
                        book={book}
                        handleBookClickBookDua={handleBookClickBookDua}
                      />
                    </div>
                  </>
                ))
              ) : (
                <p>{lg?.noBooksFound || "No books found under this Suggested books for a 1:1."}</p>
              )}
            </div>

            {/* <button
              className="mt-4 text-sm font-medium text-[var(--primary)] hover:underline"
              style={{ ["--primary"]: PRIMARY }}
            >
              See more suggestions
            </button> */}
          </aside>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered className="customseesug">
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn podclosre "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
            style={{ marginTop: "-8px" }}
          />
        </Modal.Header>
        <Modal.Title className="text-center mt-md-1 ">
          <div className="d-flex justify-content-center gap-sm-4 gap-1">
            <div
              className=" align-items-center   "
              style={{ backgroundColor: "transparent" }}
            >
              <InputGroup
                className=" outline1 outline1model"
                style={{ backgroundColor: "transparent" }}
              >
                <img
                  className=" mx-2 mt-2   mobilwid1 "
                  src={require("../pages/image/lactionicon.png")}
                  alt="logo"
                />
                <Form.Control
                  className=" placeholder-1 fw600 fs-5  ftzinput"
                  style={{
                    backgroundColor: "transparent",

                    color: "#979797",
                  }}
                  placeholder="Amsterdam"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                />
                <InputGroup.Text
                  className="mobil155 border-0"
                  id="basic-addon2"
                  style={{
                    width: "51px",
                    height: "53px",
                    marginTop: "-2px",
                    marginRight: "-2px",
                    backgroundColor: "#34C3C9",
                    borderRadius: "0px 10px 10px 0",
                  }}
                >
                  <img
                    className=" sm:w-100  mobilwid111 "
                    src={require("../pages/image/searchwhite.png")}
                    alt="logo"
                  />
                </InputGroup.Text>
              </InputGroup>
            </div>
            <div
              className="d-flex gap-2 mapimgwid py-2 justify-content-center rounded-3 fw600 fs-5 "
              style={{
                color: "#595959",
                border: "2px solid #34C3C9",
                width: "156px",
                height: "53px",
              }}
            >
              <a
                href="https://www.google.com/maps/@40.69754,-74.3093378,10z?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D" // Replace with specific Google Maps location URL if needed
                target="_blank" // Open in new tab
                rel="noopener noreferrer" // Security feature for opening a new tab
                style={{ textDecoration: "none", color: "inherit" }} // Preserve styles and text color
                className="d-flex gap-2"
              >
                  <img
                  src={require("./image/mapmodel.png")}
                  width="30"
                  height="27"
                />
                {lg?.map || "Map"}
              </a>
            </div>
          </div>
        </Modal.Title>

        <Modal.Body className="mx-sm-5 mt-md-2  ppadsmmodel  ">
          <div className="fs-4 fw-bold westeast">West Amsterdam</div>
          <div className="d-flex mt-1    gap-sm-3 gap-2 ">
            <img
              className=" cevimg  "
              src={require("../pages/image/cevtmodel.png")}
              width="330"
              height="170"
              style={{ position: "relative" }}
            />

            <div
              className="d-flex gapimagmodel mx-sm-3   align-items-center "
              style={{ position: "absolute" }}
            >
              <img
                className=" cevimgjj  "
                src={require("../pages/image/meetupmodelimg.png")}
              />
              <img
                className=" cevimgjj  "
                src={require("../pages/image/meetupmodelimg.png")}
                style={{ rotate: "180deg" }}
              />
            </div>
            <div>
              <div className="fw-bold mt-md-2 fs-4  westeast "> Podieum</div>
              <div
                className="fw600 allaptext  fs-6"
                style={{ color: "#474747" }}
              >
                A. Staalmanplein 12, 1089 AP <br />
                Amsterdam, NL
                <br />
                Phone: 06 46718100
                <br />
                Website:{" "}
                <Link
                  to="https://www.podieum.nl/"
                  className="text-primary text-decoration-underline"
                >
                  {" "}
                  https://www.podieum.nl/
                </Link>
                <br />
                <a
                  href="https://www.google.com/maps/@40.69754,-74.3093378,10z?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D" // Replace with specific Google Maps location URL if needed
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" // Security feature for opening a new tab
                  style={{ textDecoration: "none", color: "inherit" }} // Preserve styles and text color
                >
                  {lg?.seeOn || "See on"}{" "}
                  <span className="text-decoration-underline">Google Maps</span>
                </a>
              </div>
            </div>
          </div>

          <div className="d-flex mt-3 gap-sm-3 gap-2 ">
            <img
              className=" cevimg "
              src={require("../pages/image/cevtmodel.png")}
              width="330"
              height="170"
              style={{ position: "relative" }}
            />

            <div
              className="d-flex gapimagmodel mx-sm-3   align-items-center "
              style={{ position: "absolute" }}
            >
              <img
                className=" cevimgjj  "
                src={require("../pages/image/meetupmodelimg.png")}
              />
              <img
                className=" cevimgjj  "
                src={require("../pages/image/meetupmodelimg.png")}
                style={{ rotate: "180deg" }}
              />
            </div>
            <div>
              <div className="fw-bold mt-md-2 fs-4  westeast "> Podieum</div>
              <div
                className="fw600 allaptext  fs-6"
                style={{ color: "#474747" }}
              >
                A. Staalmanplein 12, 1089 AP <br />
                Amsterdam, NL
                <br />
                Phone: 06 46718100
                <br />
                Website:{" "}
                <Link
                  to="https://www.podieum.nl/"
                  className="text-primary text-decoration-underline"
                >
                  {" "}
                  https://www.podieum.nl/
                </Link>
                <br />
                <a
                  href="https://www.google.com/maps/@40.69754,-74.3093378,10z?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D" // Replace with specific Google Maps location URL if needed
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" // Security feature for opening a new tab
                  style={{ textDecoration: "none", color: "inherit" }} // Preserve styles and text color
                >
                  {lg?.seeOn || "See on"}{" "}
                  <span className="text-decoration-underline">Google Maps</span>
                </a>
              </div>
            </div>
          </div>

          <div className="fs-4 fw-bold westeast ">East Amsterdam</div>
        </Modal.Body>
      </Modal>

      <Modal
        show={wShow}
        onHide={handleCloseW}
        centered
        className="custom-gropmodelwel weldonemodel"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn24 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseW}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold mx-sm-2 text-center  aboutauther  "
            style={{ fontSize: "27px", color: "#34C3C9" }}
          >
            {lg?.wellDone || "Well done!"}
          </div>
        </Modal.Title>
        <Modal.Body className="mx-4 pt-0 mt-sm-4 mt-3">
          <div
            className=" fw-bold mx-lg-3 px-lg-5 text-center  w-100 ftzcopy   "
            style={{ fontSize: "18px" }}
          >
            {lg?.bookDuoLive || "Your Book Duo is now live."}
          </div>
          <div
            className=" fw-bold mx-lg-3 px-lg-5 mt-sm-4 mt-3 text-center  w-100 ftzcopy   "
            style={{ fontSize: "18px" }}
          >
            {lg?.willInformInterest || "We will inform you when someone shows interest!"}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showB}
        onHide={handleCloseB}
        centered
        className="custom-modalmeet"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseB}
          />
        </Modal.Header>
        <Modal.Title className="text-center mt-sm-3 "></Modal.Title>
        <Modal.Body className="mx-auto mlminmodel mt-sm-3 mt-1">
          <div className="d-flex mt-4 ">
            <div className="text-dark ftzevtt fw-bold fs-5 col-sm-3 col-3 mx-md-5 mx-sm-4 mx-2">
              {/* Book’s Cover: */}
              {lg?.bokcvr}:
            </div>
            <div>
              {/* Hidden File Input */}
              <input
                type="file"
                accept="image/*"
                id="fileInput"
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />

              <button
                className=" fw600"
                style={{
                  fontSize: "18px",
                  width: "151px",
                  height: "38px",
                  border: "2px solid #34C3C9",
                  color: "#5B5B5B",

                  cursor: "pointer",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                onClick={() => document.getElementById("fileInput").click()}
              >
                {imageName
                  ? imageName.substring(0, 7) +
                  (imageName.length > 7 ? "..." : "")
                  : lg?.upload}
              </button>
              {/* {imageName && <p style={{ marginTop: "10px" }}>📁 {imageName}</p>} */}
              {/* Image Preview */}
              {selectedImage && (
                <div className="d-none" style={{ marginTop: "10px" }}>
                  <img
                    src={selectedImage}
                    alt="Preview"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>
            <div
              className="fw600 ftzevtt d-sm-block d-none mx-md-5 mx-3 my-1"
              style={{ color: "#2B2B2B", fontSize: "18px" }}
            >
              {/* (Optional) */}({lg?.optnal})
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark fw-bold col-sm-3  col-3 ftzevtt fs-5 mx-md-5 mx-sm-4 mx-2">
              {/* Title: */}
              {lg?.title}:
            </div>

            <div className="">
              <input
                type="text"
                className="form-control modeltextwid widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="text"
                required
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  height: "38px",
                }}
                value={modalData.title}
                name="title"
                onChange={handleModalInputChange}
              />
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark ftzevtt fw-bold col-sm-3 col-3 fs-5 mx-md-5 mx-sm-4 mx-2">
              {/* Writer: */}
              {lg?.writer}:
            </div>

            <div className="">
              <input
                type="text"
                className="form-control modeltextwid widmeetupin  fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="text"
                required
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  height: "38px",
                }}
                value={modalData.writer}
                name="writer"
                onChange={handleModalInputChange}
              />
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark fw600 ftzevtt col-sm-3 col-3 fs-5 mx-md-5 mx-sm-4 mx-2">
              {/* Genre: */}
              {lg?.genre}:
            </div>

            <div className="">
              <Form.Select
                className="form-control modeltextwid  widmeetupin text-dark fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="visibilitySelect"
                // value={visibility}
                // onChange={(e) => setVisibility(e.target.value)}
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  height: "40px",
                }}
                value={modalData.genre}
                name="genre"
                onChange={handleModalInputChange}
              >
                <option value="Genre">Genre</option>
                <option value="Crime">Crime</option>
                <option value="Fiction">Fiction</option>
                <option value="Graphic Novels & Manga">
                  Graphic Novels & Manga
                </option>
                <option value="Non-Fiction">Non-Fiction</option>
                <option value="Sci-Fi & Fantasy">Sci-Fi & Fantasy</option>
                <option value="Young Adults & LGBTQ+">
                  Young Adults & LGBTQ+
                </option>
              </Form.Select>
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark fw600 ftzevtt col-sm-3 col-3 fs-5 mx-md-5 mx-sm-4 mx-2">
              {lg?.aboutbook || "About the book"}:
            </div>

            <div className="">
              <textarea
                className="form-control modeltextwid widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="aboutBook"
                value={modalData.aboutBook}
                name="aboutBook"
                onChange={handleModalInputChange}
                rows="4"
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  resize: "vertical",
                }}
                placeholder={lg?.aboutbook || "Enter a description of the book..."}
              />
            </div>
          </div>

          <div className="d-flex mladd justify-content-center mt-4">
            <button
              className="text-white subbtnmeet border-0 fs-18 fw600 rounded-1"
              style={{
                width: "135px",
                height: "44px",
                backgroundColor: "#62C0C7",
              }}
              onClick={addBookManually}
            >
              {/* Add */}
              {lg?.add}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateMeetup;
